import "./styles/App.css";
import Header from "./Header";
import { useState, useEffect, useRef } from "react";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Homepage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LodgingBusiness",
    name: "Apartman Stari Vlah Zlatibor",
    description:
      "Udoban apartman na Zlatiboru sa drvenim enterijerom i prirodnim materijalima, savršen za opuštanje i uživanje u prirodi.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Nikole Altomanovića 6",
      addressLocality: "Zlatibor",
      addressRegion: "Serbia",
      postalCode: "31315",
    },
    telephone: "+381 61 6836736",
    email: "dulebondok@gmail.com",
    url: "https://www.starivlahzlatibor.rs",
    image: "https://www.starivlahzlatibor.rs/gallery",
    priceRange: "RSD 3000 - RSD 5000",
    checkinTime: "14:00",
    checkoutTime: "11:00",
    amenityFeature: [
      {
        "@type": "LocationFeatureSpecification",
        name: "WiFi",
        value: "Available",
      },
      {
        "@type": "LocationFeatureSpecification",
        name: "Parking",
        value: "Available",
      },
      {
        "@type": "LocationFeatureSpecification",
        name: "Balcony",
        value: "Available",
      },
    ],
    geo: {
      "@type": "GeoCoordinates",
      latitude: "43.679",
      longitude: "19.593",
    },
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [hasCounted1, setHasCounted1] = useState(false);
  const [hasCounted2, setHasCounted2] = useState(false);
  const [hasCounted3, setHasCounted3] = useState(false);

  const targetNumber1 = 600;
  const targetNumber2 = 40;
  const targetNumber3 = 30;
  const navigate = useNavigate();

  useEffect(() => {
    
    const numberInfoSecondDiv = document.querySelector(
      ".numberInformationsSecondDiv"
    );
    const numberInfoThirdDiv = document.querySelector(
      ".numberInformationsThirdDiv"
    );
    const numberInfoFourthDiv = document.querySelector(
      ".numberInformationsFourthDiv"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            const targetClass = entry.target.classList[0];
            if (targetClass === "raisingNumberParagraph1" && !hasCounted1) {
              setHasCounted1(true);
              startCounting(setCount1, targetNumber1);
            } else if (
              targetClass === "raisingNumberParagraph2" &&
              !hasCounted2
            ) {
              setHasCounted2(true);
              startCounting(setCount2, targetNumber2);
            } else if (
              targetClass === "raisingNumberParagraph3" &&
              !hasCounted3
            ) {
              setHasCounted3(true);
              startCounting(setCount3, targetNumber3);
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    const numberInfoDiv1 = document.querySelector(".raisingNumberParagraph1");
    const numberInfoDiv2 = document.querySelector(".raisingNumberParagraph2");
    const numberInfoDiv3 = document.querySelector(".raisingNumberParagraph3");

    if (numberInfoSecondDiv) observer.observe(numberInfoSecondDiv);
    if (numberInfoThirdDiv) observer.observe(numberInfoThirdDiv);
    if (numberInfoFourthDiv) observer.observe(numberInfoFourthDiv);
    if (numberInfoDiv1) observer.observe(numberInfoDiv1);
    if (numberInfoDiv2) observer.observe(numberInfoDiv2);
    if (numberInfoDiv3) observer.observe(numberInfoDiv3);

    return () => {
      if (numberInfoSecondDiv) observer.unobserve(numberInfoSecondDiv);
      if (numberInfoThirdDiv) observer.unobserve(numberInfoThirdDiv);
      if (numberInfoFourthDiv) observer.unobserve(numberInfoFourthDiv);
      if (numberInfoDiv1) observer.unobserve(numberInfoDiv1);
      if (numberInfoDiv2) observer.unobserve(numberInfoDiv2);
      if (numberInfoDiv3) observer.unobserve(numberInfoDiv3);
    };
  }, [hasCounted1, hasCounted2, hasCounted3]);

  const startCounting = (setCount, targetNumber) => {
    let current = 0;
    const increment = targetNumber / 100;
    const interval = setInterval(() => {
      if (current < targetNumber) {
        current += increment;
        setCount(Math.floor(current));
      } else {
        clearInterval(interval);
      }
    }, 30);
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

   
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const images = [
    {
      desktop: "/images/roomImages/dnevna1.webp",
      mobile: "/images/roomImages/dnevna1_mobile.webp",
    },
    {
      desktop: "/images/roomImages/dnevna2.webp",
      mobile: "/images/roomImages/dnevna2_mobile.webp",
    },
    {
      desktop: "/images/roomImages/dnevna5.webp",
      mobile: "/images/roomImages/dnevna5_mobile.webp",
    },
    {
      desktop: "/images/kuhinja1.jpeg",
      mobile: "/images/roomImages/kuhinja1_mobile.webp",
    },
    {
      desktop: "/images/spavaca1.jpeg",
      mobile: "/images/roomImages/spavaca1_mobile.webp",
    },
    {
      desktop: "/images/terasa1.jpeg",
      mobile: "/images/roomImages/terasa1_mobile.webp",
    },
    {
      desktop: "/images/detalj1.jpeg",
      mobile: "/images/roomImages/detalj1_mobile.webp",
    },
  ];

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  const startInterval = () => {
    intervalRef.current = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(true);
      }, 1000);
    }, 4000);
  };

  useEffect(() => {
    startInterval();

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const currentImage =
    windowWidth <= 768
      ? images[currentImageIndex].mobile
      : images[currentImageIndex].desktop;

  return (
    <>
      <div className="homepageMainDiv">
        <Header />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemaData),
          }}
        />
        <Helmet>
          <link
            rel="stylesheet"
            href="/css/main.89359a8c.css"
            media="print"
            onLoad="this.media='all'"
          />
          <link
            rel="preload"
            href="/images/roomImages/dnevna1_mobile.webp?format=avif&w=600&quality=60"
            as="image"
            media="(max-width: 768px)"
            fetchPriority="high"
          />
          <title>Apartman Stari Vlah | Smeštaj na Zlatiboru</title>
          <meta
            name="description"
            content="Apartman Stari Vlah na Zlatiboru nudi udoban i savremeno opremljen smeštaj, idealan za vaš odmor. Smeštaj na Zlatiboru sa svim potrebnim sadržajem, rezervišite odmah!"
          />
          <meta
            name="keywords"
            content="apartman Zlatibor, smeštaj Zlatibor, apartman Stari Vlah, Zlatibor smeštaj, odmor Zlatibor, luksuzni apartman Zlatibor, jeftino Zlatibor"
          />
          <meta
            property="og:title"
            content="Apartman Stari Vlah - Smeštaj na Zlatiboru"
          />
          <meta
            property="og:description"
            content="Uživajte u udobnosti Apartmana Stari Vlah, smeštenom u srcu Zlatibora. Idealno za parove i porodice. Rezervišite odmah!"
          />
          <meta property="og:image" content="/images/logoKrug.webp" />
          <meta property="og:url" content="https://starivlahzlatibor.rs" />
          <link rel="canonical" href="https://starivlahzlatibor.rs" />
        </Helmet>

        <div className="slideshow-container">
          <div
            className={`background-image ${fade ? "fade-in" : "fade-out"}`}
            style={{
              backgroundImage: `url(${currentImage})`,
            }}
          />

          <h1 className="homepageHeader">
            APARTMAN
            <br className="breakPoint" /> STARI VLAH
          </h1>
          <h2 className="homepageSecondHeader">
            Prijatan i udoban smeštaj, savršen za porodice. Daleko od gužve, a
            ipak u samom srcu Zlatibora. &#10084;&#65039;
          </h2>

          <button
            className="homepageBookBtn"
            onClick={() => navigate("/booking")}
          >
            Proveri dostupnost
            <img
              src="/images/rightArrow.svg"
              className="bookingBtnIcon"
              alt="Raspoloživost apartmana Zlatibor - Proverite dostupne termine za smeštaj Zlatibor"
            />
          </button>
        </div>
        <div className="homepageSecondDiv">
          <h3 className="homepageParagraph">
            Dobrodošli u apartman Stari Vlah, idealno mesto za smeštaj i odmor
            na Zlatiboru. Apartman je renoviran i potpuno opremljen kako bi
            gostima pružio komforan boravak.
            <br /><br /> Smešten je u mirnoj ulici, okružen zelenilom i čistim
            vazduhom. Neposredna blizina centra Zlatibora i svih glavnih
            atrakcija pruža gostima mogućnost da uvek budu na korak od svih
            dešavanja.🌲
            <br />
            <br />
            Apartman je pre svega namenjen parovima i porodicama, ali i svima
            koji žele da se opuste i uživaju u prirodnom okruženju.
            <br />
            <br /> Potrudićemo se da vaš boravak učinimo što udobnijim i
            prijatnijim, bilo da je u pitanju pomoć sa lokalnim informacijama,
            organizacija aktivnosti ili dodatni sadržaji koji će vam učiniti
            boravak još lepšim. Dobrodošli! 😊<br></br>
            <button
              className="homepageToAboutBtn"
              onClick={() => navigate("/about")}
            >
              O NAMA{" "}
              <img
                src="/images/rightArrow.png"
                className="rightArrowAbout"
                alt="Apartman Stari Vlah Zlatibor Ikona"
              />
            </button>
          </h3>
          <motion.img
            src="/images/balcony.webp"
            className="balconyImg"
            loading="lazy"
            alt="Balkon apartmana Zlatibor - Uživajte u pogledu sa balkona tokom boravka u smeštaju Zlatibor"
            initial={{ x: 0, y: 0 }}  
            whileInView={{
              x: isMobile ? 0 : -360,
              y: isMobile ? -150 : 0,
              opacity: isMobile ? 0 : 1
            }}
            transition={{ duration: 1, delay: isMobile ? 1 : 0 }}
            viewport={{ once: true, amount: 0.4 }}
          />
          <motion.img
            src="/images/balcony.webp"
            className="balconyImgRight"
            loading="lazy"
            alt="Balkon apartmana Zlatibor - Uživajte u pogledu sa balkona tokom boravka u smeštaju Zlatibor"
            initial={{ x: 0, y: 0 }}  
            whileInView={{
              x: isMobile ? 0 : 360,
              y: isMobile ? 150 : 0,
              opacity: isMobile ? 0 : 1
            }}
          
            transition={{ duration: 1, delay: isMobile ? 1 : 0 }}
            viewport={{ once: true, amount: 0.4 }}
          />

          <div className="numberInformationsDiv">
            <div className="numberInformationsSecondDiv">
              <img
                src="/images/distance.png"
                className="informationIcon"
                loading="lazy"
                alt="Udaljenost od popularnih destinacija - Smeštaj Zlatibor"
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p className="raisingNumberParagraph1">{count1}</p>
                <p style={{ marginLeft: "-0.7vw" }}>m</p>
              </div>
              <p style={{ fontFamily: "Lora", fontSize: "1.2rem" }}>
                do centra Zlatibora
              </p>
              <div
                style={{
                  height: "2vh",
                  backgroundColor: "#c55a11",
                  width: "100%",
                  marginBottom: "-2vh",
                }}
              ></div>
            </div>
            <div className="numberInformationsThirdDiv">
              <img
                src="/images/homeIcon.png"
                className="informationIcon"
                loading="lazy"
                alt="Kućna ikona za apartman Zlatibor - Smeštaj sa udobnostima koje liče na dom"
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p className="raisingNumberParagraph2">{count2}</p>
                <p style={{ marginLeft: "-0.7vw" }}>m2</p>
              </div>
              <p style={{ fontFamily: "Lora", fontSize: "1.2rem" }}>
                udobnog prostora
              </p>
              <div
                style={{
                  height: "2vh",
                  backgroundColor: "#c55a11",
                  width: "100%",
                  marginBottom: "-2vh",
                }}
              ></div>
            </div>
            <div className="numberInformationsFourthDiv">
              <img
                src="/images/priceTag.png"
                className="informationIcon"
                loading="lazy"
                alt="Cene smeštaja Zlatibor - Pogodne ponude za apartman Zlatibor"
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p style={{ marginRight: "-1.4vw", marginTop: "1vh" }}>od</p>
                <p className="raisingNumberParagraph3">{count3}</p>
                <p style={{ marginTop: "1vh", marginLeft: "-0.6vw" }}>eura</p>
              </div>
              <p style={{ fontFamily: "Lora", fontSize: "1.2rem" }}>
                po noćenju
              </p>
              <div
                style={{
                  height: "2vh",
                  backgroundColor: "#c55a11",
                  width: "100%",
                  marginBottom: "-2vh",
                }}
              ></div>
            </div>
          </div>
        </div>
        <div className="homepageAmenitiesDiv">
          <h2 className="homepageAmenitiesHeader">
            Sadržaji u Apartmanu Stari Vlah
          </h2>
          <div className="amenitiesListDiv" id="amenitiesListDiv">
            <motion.div
              className="amenitiesDiv"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src="/images/map.png"
                className="amenitiesIcon"
                alt="Lokacija apartmana Zlatibor - Pogledajte mapu i planirajte svoj boravak u smeštaju Zlatibor"
                loading="lazy"
              />
              <h3 className="amenitiesDivHeader">Lokacija</h3>
              <p className="amenitiesDescription">
                Apartman Stari Vlah nalazi se u ulici Nikole Altomanovića broj
                6. Ova odlična lokacija gostima pruža brz i jednostavan pristup
                svim važnim sadržajima i atrakcijama ovog prelepog planinskog
                centra.
              </p>
            </motion.div>
            <motion.div
              className="amenitiesDiv"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src="/images/parking.png"
                className="amenitiesIcon"
                alt="Parking za goste apartmana Zlatibor - Sigurno parkiranje u blizini smeštaja Zlatibor"
                loading="lazy"
              />
              <h3 className="amenitiesDivHeader">Parking</h3>
              <p className="amenitiesDescription">
                Našim gostima na raspolaganju je besplatno parking mesto ispred
                ulaza u zgradu. Svoj automobil možete parkirati i sa potpunim
                mirom uživati u svom boravku.
              </p>
            </motion.div>
            <motion.div
              className="amenitiesDiv"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src="/images/wifi.png"
                className="amenitiesIcon"
                alt="WiFi u apartmanu Zlatibor - Besplatan internet tokom boravka u smeštaju Zlatibor"
                loading="lazy"
              />
              <h3 className="amenitiesDivHeader">WiFi Internet</h3>
              <p className="amenitiesDescription">
                U našem smeštaju na raspolaganju gostima je brz i pouzdan
                besplatan WiFi, idealan za rad, zabavu ili jednostavno
                planiranje vaših aktivnosti na Zlatiboru.
              </p>
            </motion.div>
            <motion.div
              className="amenitiesDiv"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src="/images/tv.png"
                className="amenitiesIcon"
                alt="TV u apartmanu Zlatibor - Udobno uživanje u TV sadržaju tokom boravka u smeštaju Zlatibor"
                loading="lazy"
              />
              <h3 className="amenitiesDivHeader">Smart TV</h3>
              <p className="amenitiesDescription">
                Uživajte u omiljenim filmovima, serijama i sadržajima na našem
                Smart TV-u, koji vam omogućava pristup aplikacijama za striming.
                Na zahtev gostiju, možemo obezbediti pristup Netflix nalogu za
                još bolji doživljaj.
              </p>
            </motion.div>
            <motion.div
              className="amenitiesDiv"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src="/images/park.png"
                className="amenitiesIcon"
                alt="Park u blizini apartmana Zlatibor - Uživajte u prirodi tokom boravka u smeštaju Zlatibor"
                loading="lazy"
              />
              <h3 className="amenitiesDivHeader">Park za decu</h3>
              <p className="amenitiesDescription">
                Deciji park koji se nalazi preko puta apartmana idealno je mesto
                za porodice sa malom decom. Mirna okolina omogućava uživanje u
                svim sadržajima, a roditelji mogu nadgledati decu iz apartmana
                ili sa klupe u parku.
              </p>
            </motion.div>
            <motion.div
              className="amenitiesDiv"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src="/images/towels.png"
                className="amenitiesIcon"
                alt="Posteljina u apartmanu Zlatibor - Čista i udobna posteljina za vaš smeštaj Zlatibor"
                loading="lazy"
              />
              <h3 className="amenitiesDivHeader">Peškiri i posteljina</h3>
              <p className="amenitiesDescription">
                U našem apartmanu pružamo svež set posteljine i peškira za
                svakog gosta. Posteljina je pažljivo odabrana kako bi obezbedila
                prijatan san, dok su peškiri mekani i čisti. Svi naši tekstili
                se redovno peru i održavaju.
              </p>
            </motion.div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Homepage;
